import React from 'react';

import { CategoryTile, Typography } from '@hpstellar/core/visId';

import { mapBundleProducts, getHeaderProps } from '../../../../get-product-props';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import { setDynamicProductData } from '../../../../../search/util';

import './product-mobile-bundle-images.less';

export default ({ product }) => {
    const priceObj = useGetProductPrice(product);
    const { bundleComponents } =
        priceObj && (!product.images || product.images.length === 0)
            ? setDynamicProductData(product, priceObj)
            : product;
    const bundles = mapBundleProducts(bundleComponents, priceObj, false);
    return Array.isArray(bundles) && (
        <div className='vis-id-mobile-bundle-images'>
            <Typography variant='footnotes' className='vis-id-mobile-bundle-images-section-title'>Bundle with</Typography>
            {
                bundles.reduce((allBundles, bundle, idx) => {
                    const {
                        bundleProductImage,
                        bundleProductTitle
                    } = bundle || {};
                    const { src, alt } = bundleProductImage || {};
                    if(bundleProductTitle && src){
                        allBundles.push(
                            <CategoryTile
                                key={idx}
                                className='vis-id-mobile-bundle-image'
                                imageWrapperClassName='vis-id-mobile-bundle-image-wrapper'
                                variant='product'
                                title={bundleProductTitle}
                                titleCentered
                                image={{
                                    src,
                                    alt
                                }}
                            />
                        )
                    }

                    return allBundles;
                }, [])
            }
        </div>
    )
}